export const ScopeEnum = {
    VALIDATION: 'validation',
    LIQUIDATION: 'liquidation',
    SUPERVISION: 'supervision',
    ADMINISTRATION: 'administration',
    EVALUATION_TC: 'evaluation_tc',
    EVALUATION_DM: 'evaluation_dm',
    CONTROL_FILE_TC: 'control_file_tc',
    CONTROL_FILE_DM: 'control_file_dm',
    VALIDATION_DGOS: 'validation_dgos',
    SURVEY_CAMPAIGN_ADMINISTRATION: 'survey_campaign'
};
